import { render, staticRenderFns } from "./SupplierMassAddForm.vue?vue&type=template&id=1795e8ba"
import script from "./SupplierMassAddForm.vue?vue&type=script&lang=js"
export * from "./SupplierMassAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports